module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "set-position",
    staticStyle: {
      "width": "100%",
      "max-width": "1200px",
      "margin": "0 auto"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "footer-right pull-right"
  }, [_vm._m(1), _vm._v(" "), _c('div', [_c('p', [_vm._v("联系电话：" + _vm._s(_vm.telephone))]), _vm._v(" "), _c('p', [_vm._v("服务时间：" + _vm._s(_vm.servicetime))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-left pull-left"
  }, [_c('div')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "footer-phone"
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "static/imgs/footer-phone.png",
      "alt": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1524352c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/G-footer.vue
// module id = 28
// module chunks = 1 5 6 7 8 9 10 11 12 13 14 15